import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItem = ({ id, index, label, onDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="trip-box-item d-flex align-items-center mb-2"
    >
      {/* Drag Handle */}
      <div
        className="icon-menu tbi-icon me-2"
        {...listeners}
        {...attributes}
      />

      <div className="tbi-circle me-2">{index + 1}</div>
      <div className="xxs-title opacity-1">{label}</div>
      <div className="dropdown ms-auto trip-list-dropdown">
        <div
          className="icon-options-vertical tbi-icon"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        />

        <ul className="dropdown-menu dropdown-menu-end">
          <li>
            <button className="dropdown-item" onClick={onDelete}>Delete</button>
          </li>
        </ul>
      </div>
    </div>
  );
}
export default SortableItem